import moment from 'moment';
import { twoDigits } from '.';

export default class extends Date {
    toFrDate() {
        const d = twoDigits(this.getDate()),
            m = twoDigits(this.getMonth() + 1),
            y = this.getFullYear();

        return `${d}/${m}/${y}`;
    }

    toFrCompactDate() {
        const d = twoDigits(this.getDate()),
            m = twoDigits(this.getMonth() + 1),
            y = this.getFullYear().toString().substr(-2);

        return `${d}/${m}/${y}`;
    }

    toFrTime() {
        const h = twoDigits(this.getHours()),
            i = twoDigits(this.getMinutes()),
            s = twoDigits(this.getSeconds());

        return `${h}:${i}:${s}`;
    }

    toFrCompactTime() {
        const h = twoDigits(this.getHours()),
            i = twoDigits(this.getMinutes());

        return `${h}:${i}`;
    }

    toFrDatetime() {
        return this.toFrDate() + ' ' + this.toFrTime();
    }

    formatDuration() {
        const now = moment(); // Current date and time
        const startDate = moment(this.toDateString()); // Parse the start date
        const duration = moment.duration(now.diff(startDate));

        // Extract days, hours, minutes, and seconds
        const days = duration.days(); // Total days
        const hours = duration.hours(); // Hours in the remaining day
        const minutes = duration.minutes(); // Minutes
        const seconds = duration.seconds(); // Seconds

        // Format the string
        return `${days}j ${hours}h ${minutes}m ${seconds}s`;
    }
}
